import { Flex, FlexProps } from 'rebass';
import React from 'react';

export type FormColumnProps = FlexProps & {
  children: React.ReactNode;
  width?: string | number | (string | number)[];
};

const FormColumn = (props: FormColumnProps): JSX.Element => {
  const { children, width, sx, ...rest } = props;
  return (
    <Flex
      flexDirection="column"
      className="form-column"
      width={width}
      {...(rest as any)}
      sx={{
        '>.form-column:first-of-type': {
          mt: 0,
        },
        ...props.sx,
      }}
    >
      {children}
    </Flex>
  );
};

export default FormColumn;
